module.exports = __webpack_public_path__ + "assets/images/basic-circle@2x-3a5f93e430e69b08fa47f711bf040c17.png";